require('./brokerMarketNewsletterView.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { connect } = require('react-redux');
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const PublicBannerNews = require('components/commons/publicBannerNews/publicBannerNews');
const BrokerDisclaimer = require('components/broker/brokerDisclaimer/brokerDisclaimer');
const { BrokerTodayKeys } = require('components/broker/brokerTodayKeys/brokerTodayKeys');
const { BrokerMarketsCalendar } = require('components/broker/brokerMarketsCalendar/brokerMarketsCalendar');
const calendarActions = require('actions/brokerMarketsCalendar');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');

class BrokerMarketNewsletterView extends React.Component {
    componentDidMount() {
        this.props.requestEvents();
    }

    render() {
        const breadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('breadcrumb-brokerMarkets'),
                url: '/myprofile/broker/markets'
            },
            {
                text: formatText('breadcrumb-brokerMarketsNewsletter'),
                url: '/myprofile/broker/newsletter'
            }
        ];

        return (
            <div className="broker-market-newsletter-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={breadcrumb}
                        finalTitle={getFinalTitle('breadcrumb-brokerMarketsNewsletter')}
                    />
                </OKCover>
                <section className="broker-market-newsletter-view__body">
                    <div className="row no-outside-gutter">
                        <section className="col-xs-8">
                            <BrokerTodayKeys />
                        </section>
                        <section className="col-xs-4">
                            <div className="broker-market-newsletter-view__banner-container">
                                <PublicBannerNews />
                            </div>
                            <BrokerMarketsCalendar
                                immBrokerMarketsCalendar={this.props.immBrokerMarketsCalendar}
                                section="markets"
                                pageName={this.props.pageName}
                            />
                        </section>
                    </div>

                    <footer className="broker-market-newsletter-view__footer">
                        <BrokerDisclaimer />
                    </footer>
                </section>
            </div>
        );
    }
}

BrokerMarketNewsletterView.propTypes = {
    brokerMarketsCalendar: PropTypes.object,
    immBrokerMarketsCalendar: PropTypes.object,
    requestEvents: PropTypes.func.isRequired,
    pageName: PropTypes.string
};

module.exports.constructor = BrokerMarketNewsletterView;
module.exports.BrokerMarketNewsletterView = connect(
    state => ({
        brokerState: state.brokerState,
        brokerMarketsCalendar: state.brokerMarketsCalendar,
        immBrokerMarketsCalendar: state.brokerMarketsCalendar
    }), {
        requestEvents: calendarActions.requestEvents
    }
)(BrokerMarketNewsletterView);